// import ComponentA from './Components/ComponentA'
import Menu from "./Components/Menu";
import Popup from "./Components/Popup";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    let root = {};
    root.menu = new Menu(root, []);
    root.menu.run();

    root.popup = new Popup(root, []);
    root.popup.run();
  },
  false
);

const buttons = document.querySelectorAll(".middle__bar_btn");

buttons.forEach((button) => {
  button.addEventListener("click", () => {
    buttons.forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");
  });
});
